{
  "projects": "Projets",
  "order_by": "Ordré par",
  "new_project": "Nouveau projet",
  "start": "Ajoutez une image qui représente le projet",
  "accepted": "Fichiers acceptés",
  "drag": "Glissez-déposé ici",
  "or": "ou",
  "browse_files": "Chercher un fichier"
}
